// DEPRECATED COMPONENT, DO NOT USE. USE ResourcesHeader from APP-COMPONENTS INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@unite-us/ui';

/**
 *
 * @visibleName ResourcesHeader DEPRECATED
 */
function ResourcesHeader(_ref) {
  var selectedProgramsAmount = _ref.selectedProgramsAmount,
    onSelectedProgramsClick = _ref.onSelectedProgramsClick,
    showAddedResourcesBtn = _ref.showAddedResourcesBtn;
  return /*#__PURE__*/React.createElement("div", {
    className: "resources-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex gap-4 items-center mb-4 justify-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "flex items-center",
    "data-testid": "resourcesHeaderText"
  }, /*#__PURE__*/React.createElement(Icon, {
    id: "resources-header-magnifying-glass-icon",
    className: "w-8 h-8 ml-3 mr-2",
    icon: "LogoShield",
    color: "#182A44"
  }), "Browse Resources")), showAddedResourcesBtn && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "bg-dark-blue text-white rounded-md p-3 relative flex gap-x-2 items-center",
    "data-testid": "addedResources",
    name: "addedResources",
    onClick: onSelectedProgramsClick()
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames('number-circle inline-flex items-center justify-center leading-8 h-6 w-6 rounded-full text-center border-2 border-solid whitespace-no-wrap', selectedProgramsAmount > 0 ? 'border-grass-green' : 'border-white')
  }, /*#__PURE__*/React.createElement("span", {
    className: "count-text inline-block text-base text-white w-full"
  }, selectedProgramsAmount)), /*#__PURE__*/React.createElement("span", {
    className: "text-white"
  }, "Added Resources"))));
}
ResourcesHeader.propTypes = {
  selectedProgramsAmount: PropTypes.number,
  onSelectedProgramsClick: PropTypes.func.isRequired,
  showAddedResourcesBtn: PropTypes.bool
};
ResourcesHeader.defaultProps = {
  selectedProgramsAmount: 0,
  showAddedResourcesBtn: false
};
export default ResourcesHeader;